import axios from 'axios';
import toast from 'react-hot-toast';

// 🎯 عدّاد بيزيد مع كل تصدير بيبدأ - زرار التصدير في السايدبار بيقارنه قبل وبعد
// ما يبعت GLOBAL_EXPORT، ولو محدش من الشاشات رد (الشاشة مالهاش تصدير خاص بفلاترها)
// بيصدّر هو الشاشة كلها بنفسه (exportScreen)
let exportsStarted = 0;
export const getExportsStarted = () => exportsStarted;

// 🎯 اسم الشاشة في السايدبار (appName) -> الكيان في /export/{entity} بالباك إند
export const EXPORT_ENTITY_BY_APP = {
  ASSET: 'assets', ASSET_CATEGORIES: 'asset-categories', CONTRACT: 'contracts',
  CRAFTS: 'crafts', DOMAINS: 'domains', FAILURE_CODES: 'failure-classes',
  GL_ACCOUNTS: 'gl-accounts', HAZARD: 'hazards', INCIDENTS: 'incidents',
  INVENTORY: 'inventory', INVENTORYUSAGE: 'invusage', INVOICE: 'invoices',
  ITEMS: 'items', JOBPLAN: 'jobplans', LABOR: 'labor', LOCATION: 'locations',
  METER: 'meters', MR: 'mr', ORGANIZATION: 'organizations', PERSON: 'persons',
  PM: 'pm', PO: 'po', PR: 'pr', PRECAUTIONS: 'precautions', RFQ: 'rfq',
  ROLE: 'roles', SAFETY: 'safetyplans', SLA: 'sla', SR: 'servicerequest',
  STOREROOMS: 'storerooms', TAGOUTS: 'tagouts', TOOLS: 'tools', USER: 'users',
  VENDORS: 'vendors', WORKORDER: 'workorders',
};

// الرد في حالة الخطأ بيرجع Blob (responseType: 'blob') - نقرا الـ detail منه
const readErrorDetail = async (error) => {
  try {
    const data = error?.response?.data;
    if (data instanceof Blob) return JSON.parse(await data.text())?.detail;
    return data?.detail;
  } catch (e) {
    return null;
  }
};

/**
 * @param {string} entityName - اسم الشاشة (ex: 'workorders')
 * @param {object} filters - الفلاتر الحالية
 * @param {object} columnsMap - قاموس الترجمة للأعمدة {"db_col": "Translated Name"} - لو فاضي الباك إند بيصدّر كل الأعمدة
 * @param {function} t - دالة الترجمة (ممررة من الشاشة)
 */
export const exportToExcel = async (entityName, filters, columnsMap, t) => {
    exportsStarted += 1;
    // 🎯 استخدام الترجمة مع توفير نص افتراضي (Fallback) باللغة الإنجليزية
    const loadId = toast.loading(t('export.loading', 'Extracting data...'));

    try {
        const token = localStorage.getItem('token');

        const response = await axios.post(`/api/export/${entityName}`, {
            filters: filters || {},
            columns: columnsMap || {}
        }, {
            headers: { 'Authorization': `Bearer ${token}` },
            responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        const disposition = response.headers['content-disposition'];
        let filename = `${entityName}_export.xlsx`;
        if (disposition && disposition.indexOf('filename=') !== -1) {
            filename = disposition.split('filename=')[1].replace(/['"]/g, '');
        }

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);

        toast.success(t('export.success', 'Exported successfully!'), { id: loadId });
    } catch (error) {
        console.error("Export Error:", error);
        const detail = await readErrorDetail(error);
        toast.error(detail || t('export.error', 'Error exporting data.'), { id: loadId });
    }
};

// 🎯 تصدير الشاشة كلها (كل السجلات المسموحة لليوزر، كل الأعمدة) للشاشات اللي
// مالهاش تصدير خاص بفلاترها
export const exportScreen = (appName, t) => {
    const entity = EXPORT_ENTITY_BY_APP[appName];
    if (!entity) {
        toast.error(t('export.notAvailable', 'Export is not available for this screen.'));
        return;
    }
    exportToExcel(entity, {}, {}, t);
};
